import React from 'react'

import {SvgIcon, SvgIconProps} from './SvgIcon'

const ShieldBadgeIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props}>
    <path
      d="M9.48669 4.53333C9.48669 4.53333 10.86 4.80666 13.8334 5.57999C16.6467 6.30666 17.6334 6.59332 17.6334 6.59332C17.6334 6.59332 17.78 9.49332 16.5 14.74C15.4734 18.9733 11.6334 21.32 9.48669 22.6467V4.53333Z"
      fill="#DFDDD9"
    />
    <path d="M12.3001 1.90668C9.40678 1.90668 6.79345 3.09334 4.91345 5.00668C4.93345 5.00001 4.96012 4.99334 4.98679 4.98668C5.48012 4.86001 5.91345 4.74668 6.32012 4.64668C7.96678 3.35334 10.0401 2.57334 12.3001 2.57334C17.6468 2.57334 22.0001 6.92668 22.0001 12.2733C22.0001 17.62 17.6468 21.9733 12.3001 21.9733C12.0935 21.9733 11.8868 21.9533 11.6801 21.94C11.3801 22.1467 11.0935 22.34 10.8135 22.52C11.3001 22.5867 11.7935 22.64 12.3001 22.64C18.0268 22.6467 22.6668 18 22.6668 12.2733C22.6668 6.54668 18.0268 1.90668 12.3001 1.90668Z" />
    <path d="M9.48672 5.21333C9.89339 5.29999 11.2534 5.59999 13.6667 6.21999C15.3867 6.65999 16.4267 6.94666 16.9667 7.09332C16.9467 8.09999 16.8001 10.6867 15.8534 14.5733C14.9401 18.3333 11.6401 20.5133 9.48672 21.8533C7.33339 20.52 4.02673 18.34 3.11339 14.58C2.17339 10.6933 2.02006 8.10666 2.00006 7.09999C2.54673 6.94666 3.58006 6.66666 5.30006 6.21999C7.71339 5.59999 9.07339 5.29999 9.48672 5.21333ZM9.48672 4.53333C9.48672 4.53333 8.11339 4.80666 5.14006 5.57999C2.32673 6.30666 1.34006 6.59332 1.34006 6.59332C1.34006 6.59332 1.19339 9.49332 2.47339 14.74C3.50006 18.9733 7.34672 21.32 9.48672 22.6467C11.6334 21.32 15.4734 18.9733 16.5001 14.74C17.7734 9.49332 17.6334 6.59332 17.6334 6.59332C17.6334 6.59332 16.6467 6.30666 13.8334 5.57999C10.8534 4.80666 9.48672 4.53333 9.48672 4.53333Z" />
    <path
      d="M9.48676 16.22C11.6333 16.22 13.3734 14.4799 13.3734 12.3333C13.3734 10.1868 11.6333 8.44666 9.48676 8.44666C7.34022 8.44666 5.6001 10.1868 5.6001 12.3333C5.6001 14.4799 7.34022 16.22 9.48676 16.22Z"
      fillOpacity={0}
      stroke="#21201F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
    <path
      d="M13.3134 9.9267L9.49338 13.7467L7.30005 11.5534"
      fillOpacity={0}
      stroke="#21201F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
  </SvgIcon>
)

export default ShieldBadgeIcon
